import { useUpdateOrgCaptchaDisabled } from "@/apiQueries/useUpdateOrgCaptchaDisabled";

import { useRedux } from "@/hooks/useRedux";
import { useSettingsToggle } from "@/hooks/useSettingsToggle";

import { CardWithToggler } from "./CardWithToggler";

export const SettingsDisableCaptcha = () => {
  const { organization } = useRedux("organization");
  const { isChecked, isPending, error, handleToggleChange } = useSettingsToggle({
    currentValue: Boolean(organization.data.captcha_disabled),
    useUpdateMutation: useUpdateOrgCaptchaDisabled,
    getNextValue: (current) => !current,
  });

  return (
    <CardWithToggler
      toggleId="captcha-disabled"
      label="Disable reCAPTCHA"
      note="Toggle this option to disable reCAPTCHA verification on login and MFA pages. When disabled, this organization will not require reCAPTCHA verification and will use the platform default setting."
      isChecked={isChecked}
      isPending={isPending}
      error={error}
      onToggleChange={handleToggleChange}
    />
  );
};
